import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, isValidElement } from 'react';
import styled from 'styled-components';
import { Columns, Column } from '@nib/layout';
import Help from '../Help';
import Label from '../Label';
import LabelWithTag from '../LabelWithTag';
import ValidationIcon from '../ValidationIcon';
import { ErrorMessage, InfoMessage } from '../ErrorMessage';
import InputWrapper from '../InputWrapper';
import defaultProps from '../common-default-props';
const ZeroFontSizeColumn = styled(Column)`
  font-size: 0;
`;
const FormControl = _ref => {
  let {
    children,
    className = defaultProps.className,
    disabled = defaultProps.disabled,
    error = defaultProps.error,
    info,
    help = defaultProps.help,
    id = defaultProps.id,
    label,
    name = defaultProps.name,
    valid = defaultProps.valid,
    validated = defaultProps.validated,
    isCompact = defaultProps.isCompact,
    formControlType,
    formType,
    width,
    isEmptyAndOptional = defaultProps.isEmptyAndOptional,
    isFullWidthSelect = false,
    fullstory = defaultProps.fullstory,
    /* eslint-disable @typescript-eslint/no-unused-vars */ //redux-formo methods
    blur,
    change,
    filter,
    focus,
    initialise,
    validate,
    //redux-form props
    active,
    filtered,
    filtering,
    initialised,
    validating,
    lastValidValue,
    /* eslint-enable @typescript-eslint/no-unused-vars */...otherProps
  } = _ref;
  const isSelectInput = children && children.type.displayName === 'Select';
  const isFileUpload = children && children.type.displayName === 'FileUploadComponent';
  const fullStoryClassName = `fs-${fullstory}`;
  const inputClasses = [fullStoryClassName];
  if (children && children.props.className) {
    inputClasses.push(children.props.className);
  }
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    "data-mesh-component": "FORM-CONTROL",
    children: [/*#__PURE__*/_jsx(Label, {
      htmlFor: id,
      isCompact: isCompact,
      disabled: disabled,
      children: formControlType ? /*#__PURE__*/_jsx(LabelWithTag, {
        label: label,
        formControlType: formControlType
      }) : label
    }), help ? /*#__PURE__*/isValidElement(help) ? /*#__PURE__*/_jsx("div", {
      id: `help-${id}`,
      children: help
    }) : /*#__PURE__*/_jsx(Help, {
      id: `help-${id}`,
      disabled: disabled,
      children: help
    }) : null, /*#__PURE__*/_jsxs(InputWrapper, {
      isSelectInput: isSelectInput,
      width: width,
      isCompact: isCompact,
      isFullWidthSelect: isFullWidthSelect,
      children: [children && /*#__PURE__*/cloneElement(children, {
        ...otherProps,
        className: inputClasses.join(' '),
        name,
        disabled,
        valid,
        validated,
        id,
        'aria-describedby': `help-${id} error-${id}`,
        'aria-invalid': validated && !valid,
        'aria-required': formControlType === 'required' || formType === 'required' && !formControlType,
        isCompact: children.props.isCompact || isCompact
      }), !isFileUpload && (validated && !valid || validated && !isEmptyAndOptional) && /*#__PURE__*/_jsx(ValidationIcon, {
        valid: valid,
        outside: isSelectInput,
        isCompact: isCompact,
        disabled: disabled
      })]
    }), isFileUpload && validated && error && /*#__PURE__*/_jsxs(Columns, {
      verticalAlign: "center",
      children: [/*#__PURE__*/_jsx(ZeroFontSizeColumn, {
        width: "content",
        children: validated && !valid && /*#__PURE__*/_jsx(ValidationIcon, {
          valid: valid,
          disabled: disabled,
          outside: true,
          isFieldset: true,
          isCompact: isCompact
        })
      }), /*#__PURE__*/_jsx(Column, {
        children: validated && error && /*#__PURE__*/_jsx(ErrorMessage, {
          valid: valid,
          disabled: disabled,
          id: `${id}`,
          error: error
        })
      })]
    }), !isFileUpload && validated && error && /*#__PURE__*/_jsx(ErrorMessage, {
      valid: valid,
      id: `${id}`,
      error: error,
      disabled: disabled
    }), validated && info && /*#__PURE__*/_jsx(InfoMessage, {
      valid: valid,
      id: `${id}`,
      info: info,
      disabled: disabled,
      fullstory: fullstory
    })]
  });
};
export default FormControl;